import { render, staticRenderFns } from "./MyDistributorSetting.vue?vue&type=template&id=2cbe5cfe"
import script from "./MyDistributorSetting.vue?vue&type=script&lang=js"
export * from "./MyDistributorSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports